import React from 'react'
import EditableNoteBox from './EditableNoteBox';
import dayjs from 'dayjs';
import {
  NotesContainer,
  StyledDivider,
} from './ShiftDetailsPanel.styles';

const DailyNotes = ({ selectedDay, liveTicket  }) => {

  const noteDate = selectedDay ? dayjs(selectedDay).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD');

  return (
    <>
      <NotesContainer>
        <EditableNoteBox
          label="EMPLOYEE NOTES"
          noteType="employee"
          placeholder="Add notes visible to everyone..."
          noteDate={noteDate}
          initialValue= {liveTicket?.employeeNotes || ''}
        />
        <StyledDivider />
        <EditableNoteBox
          label="MANAGER NOTES"
          noteType="manager"
          placeholder="Add notes visible to managers..."
          noteDate={noteDate}
          initialValue= {liveTicket?.managerNotes || ''}
        />
      </NotesContainer>
    </>
  )
}

export default DailyNotes